<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.QueryLCLJobOrder')"
    width="1085px"
    append-to-body
    :close-on-click-modal="false"
    :before-close="beforeCloseHandler"
    class="app-main-inner query-re-lcl-dialog"
  >
    <div v-if="isFba" class="app-main-inner-row">
      <search-item
        config-module="10015"
        :reset="true"
        :show-simple="false"
        :expand-adv="true"
        :col-settings="{span:8}"
        :custom-search-items="customSearchItems"
        @advSearchItemCallBack="toQueryForFba"
      />
    </div>
    <div v-if="!isFba" class="app-main-inner-row">
      <search-item
        ref="searchItem"
        config-module="301"
        :reset="true"
        :show-simple="false"
        :expand-adv="true"
        :custom-search-items="customSearchItems"
        :col-settings="{span:8}"
        :grid-config-module="100150"
        @advSearchItemCallBack="toQuery"
        @perConfigChange="value=>{perConfigName=value}"
        @refreshGrid="()=>{gridRefreshId+=1}"
      />
    </div>
    <div class="app-main-inner-row">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="dynamicColumnDefs"
        :row-data="rowData"
        style="min-height: 300px;"
        :per-config-name="perConfigName"
        :refresh-id="gridRefreshId"
        config-module="100150"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <div slot="footer" style="display: flex;justify-content: space-between;">
      <span>
        <b>{{ $t('SeaExport.QuantityOfSelectedOrder') }}：{{ selectedRows.length }}</b>
      </span>
      <div>
        <el-button no="add" type="primary" @click="add">{{ $t('SeaExport.Add3') }}</el-button>
        <el-button no="Cancel" @click="beforeCloseHandler(()=>{innerVisible=false})">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { cacheName, cache } from '@/utils/cacheManager'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { WarehouseInfo } from '@/class/model/booking/WarehouseInfo'
import { TruckingInfo } from '@/class/model/booking/TruckingInfo'
import {
  getFbaRailwayExportJobsByLclMasterJob,
  getRailwayExportJobsByLclMasterJob
} from '@/api/railwayExport/reBooking'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'QueryRELclDialog',
  components: { searchItem },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      masterLandTransportation: false,
      customSearchItems: [],
      filter: {
        jobNo: '',
        vessel: '',
        voyageFlight: '',
        forwardingAgent: '',
        customerId: '',
        destinationStation: '',
        etdStart: '',
        etdEnd: '',
        opDepartment: '',
        containerLoadType: '',
        lob: 'RE'
      },
      perConfigName: '',
      gridRefreshId: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onRowDataChanged: event => {
          // 重置（多选）选中行
          this.selectedRows = []
        },
        onSelectionChanged: event => {
          this.selectedRows = event.api.getSelectedRows()
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'),
          field: 'jobNo',
          width: 130
        }, {
          headerName: this.$t('CargoMsg.Cargo_WarehouseNo'),
          field: 'warehouseNo',
          width: 120
        }, {
          headerName: this.$t('RailwayExport.mbl'),
          field: 'mbl',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'),
          field: 'customerId',
          width: 220,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('RailwayExport.forwardingAgent'),
          field: 'forwardingAgent',
          width: 180,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('RailwayExport.destinationStation'),
          field: 'destinationStation',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        }, {
          headerName: this.$t('RailwayExport.ETD'),
          field: 'etd',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChineseCargoName'),
          field: 'cargoChineseName',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_ItemsNBR'),
          field: 'quantityActual',
          width: 90,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weightActual',
          width: 90,
          cellRenderer: params => {
            return ColumnUtils.number1ColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Cubage'),
          field: 'cubageActual',
          width: 90,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      selectedRows: [],
      gridApi: null,
      searchConditions: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    isFba() { // 是否是FBA业务
      return this.job && this.job.fba
    },
    dynamicColumnDefs() {
      let columnDefs = [
        {
          headerName: '',
          field: '',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'),
          field: 'jobNo',
          width: 130
        }, {
          headerName: this.$t('CargoMsg.Cargo_WarehouseNo'),
          field: 'warehouseNo',
          width: 120
        }, {
          headerName: this.$t('RailwayExport.mbl'),
          field: 'mbl',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'),
          field: 'customerId',
          width: 220,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('RailwayExport.forwardingAgent'),
          field: 'forwardingAgent',
          width: 180,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('RailwayExport.destinationStation'),
          field: 'destinationStation',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        }, {
          headerName: this.$t('RailwayExport.ETD'),
          field: 'etd',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChineseCargoName'),
          field: 'cargoChineseName',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_ItemsNBR'),
          field: 'quantityActual',
          width: 90,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weightActual',
          width: 90,
          cellRenderer: params => {
            return ColumnUtils.number1ColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Cubage'),
          field: 'cubageActual',
          width: 90,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.Operation'), field: 'op', width: 120, colId: 'op', hide: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op') : ''
          }
        }
      ]
      if (this.isFba) {
        columnDefs = [
          ...columnDefs,
          {
            headerName: 'FBA',
            colId: 'fba',
            field: 'fba',
            initialHide: !this.isFba,
            suppressColumnsToolPanel: !this.isFba,
            width: 70,
            valueFormatter: (params) => {
              return ColumnUtils.booleanLabelFunction(params.value)
            }
          }, {
            headerName: this.$t('SeaExport.Destination'),
            colId: 'fbaWarehouseCode',
            field: 'fbaWarehouseCode',
            initialHide: !this.isFba,
            suppressColumnsToolPanel: !this.isFba,
            width: 120
          }, {
            headerName: this.$t('RailwayExport.DomesticWarehouse'),
            colId: 'fbaWarehouseCmp',
            field: 'fbaWarehouseCmp',
            initialHide: !this.isFba,
            suppressColumnsToolPanel: !this.isFba,
            width: 120,
            valueFormatter: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_10') : ''
            }
          }, {
            headerName: this.$t('RailwayExport.OverseasWarehouse'),
            colId: 'overseaWarehouseCode',
            field: 'overseaWarehouseCode',
            initialHide: !this.isFba,
            suppressColumnsToolPanel: !this.isFba,
            width: 120,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_OverseaWarehouse, 'warehouseCode', params.value, 'chineseName')
            }
          }, {
            headerName: this.$t('RailwayExport.ExpectedToEnterAmazonWarehouse'),
            colId: 'fbaPreAmazonWhTime',
            field: 'fbaPreAmazonWhTime',
            initialHide: !this.isFba,
            suppressColumnsToolPanel: !this.isFba,
            width: 120,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('RailwayExport.ReferenceContainerNumber'),
            colId: 'fbaRefContainerNo',
            field: 'fbaRefContainerNo',
            initialHide: !this.isFba,
            suppressColumnsToolPanel: !this.isFba,
            width: 120
          }, {
            headerName: 'Shipment Id',
            colId: 'fbaShipmentId',
            field: 'fbaShipmentId',
            initialHide: !this.isFba,
            suppressColumnsToolPanel: !this.isFba,
            width: 120
          }
        ]
      }
      return columnDefs
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.initData()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    initCustomSearchItems() {
      // 头程主票加入小票高级查询
      // FBA
      let searchField = new AdvancedSearchField()
      searchField.multiple = 0
      searchField.defaultValue = true
      searchField.itemLabel = 'FBA'
      searchField.itemName = 'job.FBA'
      searchField.itemValue = ''
      searchField.fieldType = 'FIELD_CHECKBOX'
      searchField.lock = true
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      this.customSearchItems.push(searchField.formatObj2Json())

      // 海外仓
      const overseaWarehouses = getCacheListByKey(basicCacheKeys.basic_data_OverseaWarehouse)
      // 目的地
      searchField = new AdvancedSearchField()
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField.itemType = 'overseaWarehouse'
      searchField.fieldType = 'FIELD_OVERSEA_WAREHOUSE'
      searchField.subType = 'cascader'
      searchField.defaultConditionVal = '='
      searchField.itemName = 'fbaJob.WAREHOUSE_CODE'
      searchField.itemLabel = this.$t('CargoMsg.Cargo_Destination')
      searchField.tagName = 'warehouseCode'
      searchField.tagValue = 'warehouseCode'
      searchField.defaultSelected = 1
      searchField.dataProvider = overseaWarehouses
      this.customSearchItems.push(searchField.formatObj2Json())

      // 国内仓
      searchField = new AdvancedSearchField()
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField.itemType = 'company'
      searchField.subType = {
        'type': 'warehouse',
        'tagValue': 'cmpIdx'
      }
      searchField.fieldType = 'FIELD_WAREHOUSE'
      searchField.itemName = 'fbaJob.DOMESTIC_WAREHOUSE'
      searchField.itemLabel = this.$t('RailwayExport.DomesticWarehouse')
      searchField.defaultSelected = 0
      searchField.dataProvider = []
      this.customSearchItems.push(searchField.formatObj2Json())

      // 国外仓
      searchField = new AdvancedSearchField()
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'job.OVERSEA_WAREHOUSE_CODE'
      searchField.itemLabel = this.$t('RailwayExport.OverseasWarehouse')
      searchField.tagName = 'countryChineseName'
      searchField.tagValue = 'warehouseCode'
      searchField.defaultSelected = 0
      searchField.dataProvider = overseaWarehouses.filter(p => !p.ifFba)
      this.customSearchItems.push(searchField.formatObj2Json())

      // 预期入亚马逊仓时间
      searchField = new AdvancedSearchField()
      searchField.itemType = 'date'
      searchField.itemCondition = []
      searchField.defaultConditionVal = 'RANGE'
      searchField.fieldType = 'FIELD_DATE_RANGE'
      searchField.itemName = 'fbaJob.PRE_AMAZON_WH_TIME'
      searchField.itemLabel = 'FbaJob.PreAmazonWhTime'
      searchField.subType = 'range'
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = []
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())

      // 中文品名
      searchField = new AdvancedSearchField()
      searchField.itemType = 'input'
      searchField.subType = ''
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemName = 'job.CARGO_CHINESE_NAME'
      searchField.itemLabel = 'SeaExport.ChineseDescriptionOfGoods'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())

      // 英文品名
      searchField = new AdvancedSearchField()
      searchField.itemType = 'input'
      searchField.subType = ''
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemName = 'job.CARGO_ENGLISH_NAME'
      searchField.itemLabel = 'SeaExport.EnglishDescriptionOfGoods'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())

      // 参考箱号
      searchField = new AdvancedSearchField()
      searchField.itemType = 'input'
      searchField.subType = ''
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemName = 'warehouseIn.REF_CONTAINER_NO'
      searchField.itemLabel = 'Warehouse.RefContainerNo'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())

      // Shipment Id
      searchField = new AdvancedSearchField()
      searchField.itemType = 'input'
      searchField.subType = ''
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemName = 'fbaJob.SHIPMENT_ID'
      searchField.itemLabel = 'FbaJob.ShipmentId'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())
    },
    async initData() {
      await cache.load(cacheName.CONFIG)
      this.masterLandTransportation = Number(cache.config.get('isMasterLandTransportation')) !== 0
      const isJyd = String(cache.config.get('ToExoSystem')) === 'JYD'
      const isAdmin = this.$store.getters.isAdmin

      if (this.isFba) {
        this.initCustomSearchItems()
      } else {
        let searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.defaultConditionVal = '='
        searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
        searchField.itemName = 'job.LOB'
        searchField.itemLabel = 'CargoMsg.Cargo_BusinessType'
        searchField.defaultSelected = 1
        searchField.selected = 1
        searchField.defaultValue = this.job.lob
        searchField.valueExpression = {
          valueType: 'static',
          valueContent: [{ code: 'RE', chineseName: this.$t('RailwayExport.Export'), englishName: 'Export' }, { code: 'RI', chineseName: this.$t('RailwayExport.Import'), englishName: 'Import' }]
        }
        searchField.lock = true
        this.customSearchItems = [searchField.formatObj2Json()]
        // 操作部门使用主票操作部门，且不可编辑
        searchField = new AdvancedSearchField()
        searchField.itemType = 'department5'
        searchField.multiple = 1
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_DEPARTMENT5'
        searchField.itemName = 'job.OP_DEPARTMENT'
        searchField.itemLabel = 'SeaExport.OperationDepartment'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 1
        searchField.lock = true
        searchField.defaultValue = [this.job.opDepartment]
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        this.customSearchItems.push(searchField.formatObj2Json())

        // CARGO-42713 加入小票查询权限逻辑优化-只能操作看自己的
        searchField = new AdvancedSearchField()
        searchField.itemType = 'user'
        searchField.subType = {
          'category': 'role',
          'shape': 'op'
        }
        searchField.multiple = 0
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_USER'
        searchField.itemName = 'job.OP_ID'
        searchField.itemLabel = 'SeaExport.Operation'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 1
        searchField.lock = (isJyd && !isAdmin)
        searchField.defaultValue = (isJyd && !isAdmin) ? this.$store.getters.userId : 0
        searchField.action = this.isFba ? AdvancedSearchField.REMOVE_ACTION : AdvancedSearchField.UPDATE_ACTION
        this.customSearchItems.push(searchField.formatObj2Json())

        searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'job.CONTAINER_LOAD_TYPE'
        searchField.itemLabel = 'SeaExport.OperateType'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 1
        searchField.lock = true
        searchField.valueExpression = ''
        searchField.dropdownDataRef = 'SeaExportConstants.CONTAINER_LOAD_TYPES'
        searchField.dataCacheKey = 'local_cache_SeaExportConstants$CONTAINER_LOAD_TYPES'
        searchField.defaultValue = [this.job.containerLoadType]
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        this.customSearchItems.push(searchField.formatObj2Json())
        this.filter.opDepartment = this.job.opDepartment
        this.filter.containerLoadType = this.job.containerLoadType
      }
    },
    toQueryForFba(conditions) {
      this.selectedRows = []
      if (typeof conditions === 'undefined' || !conditions || conditions.length === 0) {
        conditions = []
      }
      if (this.job.opDepartment && this.job.opDepartment > 0) {
        conditions.push(new AdvancedSearchOption(null, 'job.OP_DEPARTMENT', this.job.opDepartment, AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json())
      }
      conditions.push(new AdvancedSearchOption(null, 'job.FBA', this.isFba, AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json())
      this.loading = getLoading('search')
      getFbaRailwayExportJobsByLclMasterJob({ conditions, branchId: this.$store.getters.currentOfficeId, pageNum: this.searchConditions.pageNum, pageSize: this.searchConditions.pageSize }).then(res => {
        this.rowData = []
        if (res.data) {
          this.rowData = res.data
        }
        this.searchConditions.total = res.data && res.data.length > 0 ? Number(res.data.length) : 0
      }).finally(() => {
        this.loading.close()
      })
    },
    toQuery(data) {
      let option = AdvancedSearchOption.getOption('job.JOB_NO', data)
      if (option) {
        this.filter.jobNo = option.value
      } else {
        this.filter.jobNo = ''
      }
      option = AdvancedSearchOption.getOption('job.VESSEL', data)
      if (option) {
        this.filter.vessel = option.value
      } else {
        this.filter.vessel = ''
      }
      option = AdvancedSearchOption.getOption('job.VOYAGE_FLIGHT', data)
      if (option) {
        this.filter.voyageFlight = option.value
      } else {
        this.filter.voyageFlight = ''
      }
      option = AdvancedSearchOption.getOption('job.CARRIER_ID', data)
      if (option) {
        this.filter.forwardingAgent = option.value
      } else {
        this.filter.forwardingAgent = ''
      }
      option = AdvancedSearchOption.getOption('job.CUSTOMER_ID', data)
      if (option) {
        this.filter.customerId = option.value
      } else {
        this.filter.customerId = ''
      }
      option = AdvancedSearchOption.getOption('job.DISCHARGING_PORT_CODE', data)
      if (option) {
        this.filter.destinationStation = option.value
      } else {
        this.filter.destinationStation = ''
      }
      option = AdvancedSearchOption.getOption('job.ETD', data)
      this.filter.etdStart = ''
      this.filter.etdEnd = ''
      if (option) {
        const items = option.value.split(',')
        for (let i = 1; i < items.length && i < 3; ++i) {
          if (items[i].startsWith('start=')) {
            this.filter.etdStart = items[i].substr(6)
          } else if (items[i].startsWith('end=')) {
            this.filter.etdEnd = items[i].substr(4)
          }
        }
      }
      option = AdvancedSearchOption.getOption('job.LOB', data)
      if (option) {
        this.filter.lob = option.value
      } else {
        this.filter.lob = 'RE'
      }
      option = AdvancedSearchOption.getOption('job.OP_ID', data)
      if (option) {
        this.filter.op = option.value
      } else {
        this.filter.op = 0
      }
      getRailwayExportJobsByLclMasterJob(this.$store.getters.currentOfficeId, this.filter).then(res => {
        this.rowData = res.data
      })
    },
    async add() {
      const selectedRows = this.selectedRows // 记录当前选中的记录，避免后续被修改
      if (selectedRows.length === 0) {
        this.$message.info(this.$t('Message.SelectTheOrderYouWantToJoin'))
        return
      }
      for (const job of selectedRows) {
        if (job.lclMasterUuid) {
          this.$message.warning(job.jobNo + ' ' + this.$t('Message.HasJoinIntoMbl'))
          return
        }
      }
      const triggerCallback = () => {
        this.$emit('callback', selectedRows)
        this.innerVisible = false
      }
      if (!(this.hasDiffField(selectedRows))) {
        this.$confirm(this.$t('Message.TheSubBillsAndMBLAreInconsistentTheSystemWillModifyTheSubBillsContinue'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning',
          closeOnClickModal: false
        }).then(() => {
          this.fixNewSlave(selectedRows)
          triggerCallback()
        }).catch(() => { })
      } else {
        triggerCallback()
      }
    },
    hasDiffField(selectedRows) {
      for (const slave of selectedRows) {
        if (slave.vessel !== this.job.vessel) {
          return false
        }
        if (slave.voyageFlight !== this.job.voyageFlight) {
          return false
        }
        if (slave.destinationStation !== this.job.destinationStation) {
          return false
        }
        if (!slave.etd && this.job.eta || slave.etd !== this.job.etd) {
          return false
        }
        if (!(!slave.eta && !this.job.eta) && (!slave.eta && this.job.eta || slave.eta && !this.job.eta || slave.eta !== this.job.eta)) {
          return false
        }
      }
      return true
    },
    fixNewSlave(selectedRows) {
      for (const item of selectedRows) {
        if (item.customs && item.customsBroker === 0) {
          item.customsBroker = this.job.customsBroker
        }
        item.etd = this.job.etd
        item.eta = this.job.eta
        item.vessel = this.job.vessel
        item.voyageFlight = this.job.voyageFlight
        item.departureStation = this.job.departureStation
        item.destinationStation = this.job.destinationStation
        if (this.masterLandTransportation) {
          item.landTransportation = this.job.isLandTransportation
        }
        item.carryingCmp = this.job.carryingCmp
        item.trucking = item.trucking || []
        if (item.trucking.length === 0) {
          const newData = new TruckingInfo().fillDefaultValue().getData()
          newData.jobUuid = item.uuid
          item.trucking.push(newData)
        }
        item.trucking[0].carryingCmp = item.carryingCmp || 0
        item.warehouseCmp = this.job.warehouseCmp
        item.warehouseInfo = item.warehouseInfo || []
        if (item.warehouseInfo.length === 0) {
          const newData = new WarehouseInfo().fillDefaultValue().getData()
          newData.jobUuid = item.uuid
          item.warehouseInfo.push(newData)
        }
        item.warehouseInfo[0].warehouseCmp = item.warehouseCmp || 0
      }
    },
    beforeCloseHandler(done) {
      this.$confirm(this.$t('Message.CancelTheCurrentQuery'), this.$t('CargoMsg.Cargo_ConfirmR'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        done()
      }).catch(() => { })
    }
  }
}
</script>

<style lang="scss">
.app-main-inner.query-re-lcl-dialog {
  label {
    font-size: 12px;
    font-weight: normal;
  }
  .el-select {
    width: 100%;
  }
}
</style>
